<app-auth></app-auth>
<div class="justify-content-end navbar-collapse collapse" id="basic-navbar-nav">
    <div class="justify-content-end navbar-nav">
        <button type="button" class="mt-0 mb-0 m-2 btn btn-success" (click)="openLoginComponent()">Login</button>
        <button type="button" class="mt-0 mb-0 m-2 btn btn-success" (click)="openSignupComponent()">
            <img src="/assets/images/icons/icons8-registration.svg" alt="">Register</button>
    </div>
</div>
